import { request } from 'utils/request';

const hiikoEnvApi = {
  getEnvs: () => {
    return request({
      url: 'hiiko_environment',
    });
  },
  createEnv: (countryCode: string, name: string) => {
    return request({
      method: 'POST',
      url: 'hiiko_environment',
      data: {
        countryCode,
        name,
      },
    });
  },
  archiveHiikoEnvironment: (envId: number) => {
    return request({
      method: 'POST',
      url: `hiiko_environment/${envId}/archive`,
    });
  },
};

export default hiikoEnvApi;
